import { useContext, useState } from 'react';
import SearchMenu from '../filters-menu/menu-select-filter/SearchMenu';
import {
  SearchContext,
  SearchContextInterface
} from '../../context/SearchContext';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import { useTranslation } from 'next-i18next';
import UpArrowIcon from '../../../../public/assets/icons/common/UpArrow';

interface AffordabilityStepperProps {
  areas: any;
  compounds: any;
  customAreas: any;
  customCompounds: any;
  setCustomAreas: any;
  setCustomCompounds: any;
}

const AffordabilityFirstStep = ({
  areas,
  compounds,
  customAreas,
  customCompounds,
  setCustomAreas,
  setCustomCompounds
}: AffordabilityStepperProps) => {
  const { t } = useTranslation('search');
  const [menu, setMenu] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState('');

  const mapToFilterOptions = (filterOptions: []) => {
    return filterOptions?.map((option: any) => ({
      value: option?.id,
      options: { displayedValue: option?.name },
      areaId: drawerTitle === 'areas' ? option?.id : option?.area_id
    }));
  };

  const filters = {
    areas: {
      name: 'areas',
      options: areas.map((area: any) => ({ ...area, areaId: area.id }))
    },
    compounds: {
      name: 'compounds',
      options: mapToFilterOptions(compounds)
    }
  };

  const selectedFilter = filters[drawerTitle as keyof typeof filters] || {
    options: []
  };

  const renderButtonText = (type: 'areas' | 'compounds') => {
    const customItems = type === 'compounds' ? customCompounds : customAreas;
    const source = type === 'compounds' ? compounds : areas;
    const fallback = type === 'compounds' ? t('any_project') : t('any_area');

    if (customItems.length === 0) {
      return fallback;
    }

    const displayItems = customItems.map((id: any) => {
      if (type === 'compounds') {
        return source.find((item: any) => item.id === id);
      }
      return source.find((item: any) => item.value === id);
    });

    return (
      <span>
        {displayItems.slice(0, 2).map((item: any, index: number) =>
          type === 'compounds' ? (
            <span key={item.id}>
              {item.name}
              {index < 1 && index !== displayItems.length - 1 ? ', ' : ' '}
            </span>
          ) : (
            <span key={item.value}>
              {item.options.displayedValue}
              {index < 1 && index !== displayItems.length - 1 ? ', ' : ' '}
            </span>
          )
        )}
        {displayItems.length > 2 && (
          <span className="option-button">
            {`+ ${displayItems.length - 2} ${t('more')}`}
          </span>
        )}
      </span>
    );
  };

  return (
    <>
      <div className="step-question-container">
        <div className="step-question">
          <span className="highlighted">
            {t('stepper_secondq_highlighted')}{' '}
          </span>

          <span>{t('stepper_secondq')}</span>
        </div>
        <button
          onClick={() => {
            setDrawerTitle('areas'), setMenu(true);
          }}
        >
          {renderButtonText('areas')}
          <UpArrowIcon />
        </button>
      </div>
      <div className="affordability-separator" />
      <div className="step-question-container">
        <div className="step-question">
          <span>{t('stepper_firstq')}</span>{' '}
          <span className="highlighted">{t('stepper_firstq_highlighted')}</span>
        </div>
        <button
          onClick={() => {
            setDrawerTitle('compounds'), setMenu(true);
          }}
        >
          {renderButtonText('compounds')}

          <UpArrowIcon />
        </button>
      </div>

      {menu && (
        <SearchMenu
          customAreas={customAreas}
          customCompounds={customCompounds}
          setCustomCompounds={setCustomCompounds}
          setCustomAreas={setCustomAreas}
          isCustomSelect={true}
          filterName={drawerTitle}
          options={selectedFilter.options}
          type={
            drawerTitle === 'areas'
              ? SearchFiltersTypes.AREAS
              : SearchFiltersTypes.COMPOUNDS
          }
          setAreasDevelopersMenu={setMenu}
        />
      )}
    </>
  );
};

export default AffordabilityFirstStep;
